export default __webpack_public_path__ + "static/media/open.cd222642.jpg";